import React, { useState, useEffect } from 'react';
import { useSetStoreValue, useStore } from 'react-context-hook'
import { ImageBackground, View, ScrollView } from 'react-native'
import { Layouts } from '../../utils'
import Styles from '../../Styles'
import * as Logger from '../../utils/Logger/index'
import { Container, H1,  Header,  Title,  Button,  Card,  CardItem,  Icon,  Text,  Left,  Right,  Body, List, ListItem, Thumbnail, Content, Picker, Form, Item, Label, Tab, Tabs, TabHeading } from 'native-base';
import { colorPalette } from '../../utils/Styles';

export default function ContactScreenMain({ navigation }) { 

    //adds the menu buttons to the header
    Layouts.StackNavigationHeader({navigation});

    return(
        <View>
            <Text>Contact Us Screen</Text>
        </View>
    )
 }